import React from 'react';
import { colors } from 'design-system';
import VectorIcon from './VectorIcon';

const CameraIcon = (): JSX.Element => (
  <VectorIcon width={56} height={56}>
    <circle
      cx="28"
      cy="28"
      r="26"
      fill="#0D2E68"
      stroke="url(#paint0_linear_6063_46883)"
      strokeWidth="4"
    />
    <path
      d="M23.9883 14.4375H30.9551C32.1445 14.4375 33.1641 15.2305 33.5039 16.3066L34.127 18.0625H38.375C40.3574 
      18.0625 42 19.7051 42 21.6875V36.1875C42 38.2266 40.3574 39.8125 38.375 39.8125H16.625C14.5859 39.8125 13 
      38.2266 13 36.1875V21.6875C13 19.7051 14.5859 18.0625 16.625 18.0625H20.8164L21.4395 16.3066C21.7793 
      15.2305 22.7988 14.4375 23.9883 14.4375ZM27.5 34.375C30.502 34.375 32.9375 31.9395 32.9375 28.9375C32.9375 
      25.9355 30.502 23.5 27.5 23.5C24.4414 23.5 22.0625 25.9355 22.0625 28.9375C22.0625 31.9395 24.4414 34.375 27.5 34.375Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_6063_46883"
        x1="28"
        y1="4"
        x2="28"
        y2="52"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor={colors.bright_turquoise} />
        <stop offset="1" stopColor="#CEE8FF" />
      </linearGradient>
    </defs>
  </VectorIcon>
);

export default CameraIcon;
